module.exports = __webpack_public_path__ + "de507cbb34bc118687055e7c2cc61ab5.MP3";